/**
 * WeatherFullscreen - Animated weather overlay with transparent background
 * Uses clip-path and transform animations only (no opacity for chromakey)
 */

const WeatherIcon = ({ code, size = 120 }) => {
  if (code === 0) {
    return (
      <svg width={size} height={size} viewBox="0 0 100 100" fill="none">
        <circle cx="50" cy="50" r="20" fill="#FCD34D" stroke="#F59E0B" strokeWidth="3"/>
        <g stroke="#F59E0B" strokeWidth="3" strokeLinecap="round">
          <line x1="50" y1="10" x2="50" y2="22"/><line x1="50" y1="78" x2="50" y2="90"/>
          <line x1="10" y1="50" x2="22" y2="50"/><line x1="78" y1="50" x2="90" y2="50"/>
          <line x1="21.7" y1="21.7" x2="30.2" y2="30.2"/><line x1="69.8" y1="69.8" x2="78.3" y2="78.3"/>
          <line x1="21.7" y1="78.3" x2="30.2" y2="69.8"/><line x1="69.8" y1="30.2" x2="78.3" y2="21.7"/>
        </g>
      </svg>
    );
  } else if (code === 1 || code === 2) {
    return (
      <svg width={size} height={size} viewBox="0 0 100 100" fill="none">
        <circle cx="35" cy="35" r="15" fill="#FCD34D" stroke="#F59E0B" strokeWidth="2"/>
        <g stroke="#F59E0B" strokeWidth="2" strokeLinecap="round">
          <line x1="35" y1="8" x2="35" y2="15"/><line x1="35" y1="55" x2="35" y2="48"/>
          <line x1="8" y1="35" x2="15" y2="35"/><line x1="55" y1="35" x2="48" y2="35"/>
        </g>
        <path d="M75 70H30C22.3 70 16 63.7 16 56C16 48.3 22.3 42 30 42C30.7 42 31.4 42.1 32.1 42.2C34.5 34.8 41.5 29.5 50 29.5C60.5 29.5 69 38 69 48.5C69 49.2 69 49.9 68.9 50.6C74.5 51.9 79 56.9 79 63C79 66.9 77.4 70 75 70Z" fill="#E5E7EB" stroke="#9CA3AF" strokeWidth="2"/>
      </svg>
    );
  } else if (code === 3 || code === 45 || code === 48) {
    return (
      <svg width={size} height={size} viewBox="0 0 100 100" fill="none">
        <path d="M80 55H25C15.1 55 7 46.9 7 37C7 27.1 15.1 19 25 19C26.1 19 27.2 19.1 28.2 19.3C31.7 9.3 41.2 2 52.5 2C66.5 2 78 13.5 78 27.5C78 28.5 78 29.5 77.8 30.5C85.3 32.3 91 39 91 47C91 51.4 86 55 80 55Z" fill="#9CA3AF" stroke="#6B7280" strokeWidth="2"/>
        <path d="M70 75H20" stroke="#6B7280" strokeWidth="4" strokeLinecap="round"/>
        <path d="M80 85H30" stroke="#6B7280" strokeWidth="4" strokeLinecap="round"/>
        <path d="M60 95H40" stroke="#6B7280" strokeWidth="4" strokeLinecap="round"/>
      </svg>
    );
  } else if ((code >= 51 && code <= 67) || (code >= 80 && code <= 82)) {
    return (
      <svg width={size} height={size} viewBox="0 0 100 100" fill="none">
        <path d="M75 45H25C16.7 45 10 38.3 10 30C10 21.7 16.7 15 25 15C25.9 15 26.8 15.1 27.7 15.2C30.6 7.1 38.4 1 47.5 1C59 1 68.5 10.5 68.5 22C68.5 22.8 68.5 23.6 68.4 24.4C74.5 25.9 79 31.4 79 38C79 42 77.3 45 75 45Z" fill="#60A5FA" stroke="#3B82F6" strokeWidth="2"/>
        <line x1="30" y1="55" x2="25" y2="75" stroke="#3B82F6" strokeWidth="3" strokeLinecap="round"/>
        <line x1="50" y1="55" x2="45" y2="80" stroke="#3B82F6" strokeWidth="3" strokeLinecap="round"/>
        <line x1="70" y1="55" x2="65" y2="70" stroke="#3B82F6" strokeWidth="3" strokeLinecap="round"/>
        <line x1="40" y1="70" x2="35" y2="90" stroke="#3B82F6" strokeWidth="3" strokeLinecap="round"/>
        <line x1="60" y1="65" x2="55" y2="85" stroke="#3B82F6" strokeWidth="3" strokeLinecap="round"/>
      </svg>
    );
  } else if ((code >= 71 && code <= 77) || (code >= 85 && code <= 86)) {
    return (
      <svg width={size} height={size} viewBox="0 0 100 100" fill="none">
        <path d="M75 45H25C16.7 45 10 38.3 10 30C10 21.7 16.7 15 25 15C25.9 15 26.8 15.1 27.7 15.2C30.6 7.1 38.4 1 47.5 1C59 1 68.5 10.5 68.5 22C68.5 22.8 68.5 23.6 68.4 24.4C74.5 25.9 79 31.4 79 38C79 42 77.3 45 75 45Z" fill="#BFDBFE" stroke="#93C5FD" strokeWidth="2"/>
        <circle cx="30" cy="60" r="4" fill="#60A5FA"/><circle cx="50" cy="70" r="4" fill="#60A5FA"/>
        <circle cx="70" cy="58" r="4" fill="#60A5FA"/><circle cx="40" cy="82" r="4" fill="#60A5FA"/>
        <circle cx="60" cy="88" r="4" fill="#60A5FA"/><circle cx="25" cy="78" r="3" fill="#93C5FD"/>
        <circle cx="75" cy="75" r="3" fill="#93C5FD"/>
      </svg>
    );
  } else if (code >= 95) {
    return (
      <svg width={size} height={size} viewBox="0 0 100 100" fill="none">
        <path d="M75 40H25C16.7 40 10 33.3 10 25C10 16.7 16.7 10 25 10C25.9 10 26.8 10.1 27.7 10.2C30.6 2.1 38.4 -4 47.5 -4C59 -4 68.5 5.5 68.5 17C68.5 17.8 68.5 18.6 68.4 19.4C74.5 20.9 79 26.4 79 33C79 37 77.3 40 75 40Z" fill="#4B5563" stroke="#374151" strokeWidth="2"/>
        <polygon points="55,45 40,70 48,70 42,95 65,62 55,62 62,45" fill="#FCD34D" stroke="#F59E0B" strokeWidth="2"/>
      </svg>
    );
  }
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none">
      <path d="M80 60H25C14.5 60 6 51.5 6 41C6 30.5 14.5 22 25 22C26.2 22 27.4 22.1 28.5 22.4C32 11.6 42.2 4 54 4C69.5 4 82 16.5 82 32C82 33 82 34 81.8 35C89.5 37 95 44 95 52C95 56.4 88.3 60 80 60Z" fill="#E5E7EB" stroke="#9CA3AF" strokeWidth="2"/>
    </svg>
  );
};

const WindArrow = ({ direction, size = 60 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" style={{ transform: `rotate(${direction}deg)` }}>
    <circle cx="50" cy="50" r="45" fill="none" stroke="rgba(255,255,255,0.3)" strokeWidth="2"/>
    <polygon points="50,15 35,60 50,50 65,60" fill="#FFFFFF"/>
    <text x="50" y="92" textAnchor="middle" fontSize="14" fontWeight="bold" fill="rgba(255,255,255,0.6)">N</text>
  </svg>
);

export function WeatherFullscreen({ weatherData, weatherLeaving, isVmix, sommertravetMode }) {
  if (!weatherData) return null;

  return (
    <div 
      data-testid="weather-view"
      style={{ 
        backgroundColor: 'transparent',
        height: '100vh', 
        width: '100vw', 
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 120px',
        boxSizing: 'border-box',
        position: 'relative'
      }}
    >
      {/* Main weather card */}
      <div
        className={weatherLeaving ? 'weather-card-exit' : 'weather-card-enter'}
        data-testid="weather-card"
        style={{
          backgroundColor: '#050F23',
          borderRadius: '20px',
          border: '3px solid var(--theme-panel-border, rgba(255,215,0,0.5))',
          boxShadow: '0 0 60px rgba(0,0,0,0.8)',
          width: '70%',
          maxWidth: '950px',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          zIndex: 1,
          position: 'relative'
        }}
      >
        {/* Header */}
        <div 
          className={weatherLeaving ? 'weather-header-exit' : 'weather-header-enter'}
          style={{
            background: 'linear-gradient(135deg, var(--theme-header-gradient, rgba(30,58,95,0.9)) 0%, transparent 100%)',
            borderBottom: '3px solid var(--theme-panel-border, rgba(255,215,0,0.5))',
            color: '#FFFFFF', padding: '24px 32px',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between'
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <WeatherIcon code={weatherData.weather_code} size={70} />
            <div>
              <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '2.8rem', fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', lineHeight: 1, color: 'var(--theme-accent, #FFD700)' }}>
                VÆR
              </div>
              <div style={{ fontFamily: "'Inter', sans-serif", fontSize: '1.3rem', color: 'rgba(255,255,255,0.6)', marginTop: '4px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                {weatherData.track_name}
              </div>
            </div>
          </div>
          <div style={{ fontFamily: "'JetBrains Mono', monospace", textAlign: 'right' }}>
            <div style={{ color: 'var(--theme-accent, #FFD700)', fontWeight: 600, fontSize: '1.4rem', textTransform: 'uppercase' }}>
              {weatherData.weather_description}
            </div>
            <div style={{ fontSize: '1.1rem', marginTop: '4px', color: 'rgba(255,255,255,0.5)' }}>
              {new Date(weatherData.date + 'T12:00').toLocaleDateString('nb-NO', { weekday: 'long', day: 'numeric', month: 'long' })}
            </div>
          </div>
        </div>

        {/* Main weather data - 3 columns */}
        <div style={{ display: 'flex', alignItems: 'stretch' }}>
          {/* Temperature */}
          <div 
            className={weatherLeaving ? 'weather-col-exit weather-col-exit-1' : 'weather-col-enter weather-col-enter-1'}
            style={{ flex: 1, padding: '36px 28px', textAlign: 'center', borderRight: '1px solid rgba(255,255,255,0.08)' }}
          >
            <WeatherIcon code={weatherData.weather_code} size={100} />
            <div style={{
              fontFamily: "'JetBrains Mono', monospace", fontSize: '5rem',
              fontWeight: 700, color: '#FFFFFF', lineHeight: 1, marginTop: '16px'
            }}>
              {weatherData.temperature}°
            </div>
            <div style={{ fontFamily: "'Inter', sans-serif", fontSize: '1.15rem', color: 'rgba(255,255,255,0.5)', marginTop: '8px' }}>
              Føles som {weatherData.feels_like}°
            </div>
          </div>

          {/* Wind */}
          <div 
            className={weatherLeaving ? 'weather-col-exit weather-col-exit-2' : 'weather-col-enter weather-col-enter-2'}
            style={{ flex: 1, padding: '36px 28px', textAlign: 'center', borderRight: '1px solid rgba(255,255,255,0.08)' }}
          >
            <WindArrow direction={weatherData.wind_direction} size={100} />
            <div style={{
              fontFamily: "'JetBrains Mono', monospace", fontSize: '3rem',
              fontWeight: 700, color: '#FFFFFF', marginTop: '16px'
            }}>
              {weatherData.wind_speed} m/s
            </div>
            <div style={{ fontFamily: "'Inter', sans-serif", fontSize: '1.15rem', color: 'rgba(255,255,255,0.5)', marginTop: '8px' }}>
              {weatherData.wind_direction_text} vind
            </div>
          </div>

          {/* Details */}
          <div 
            className={weatherLeaving ? 'weather-col-exit weather-col-exit-3' : 'weather-col-enter weather-col-enter-3'}
            style={{ flex: 1, padding: '36px 28px', display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: '24px' }}
          >
            <div>
              <div style={{ fontFamily: "'Inter', sans-serif", fontSize: '0.95rem', color: 'var(--theme-accent, #FFD700)', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Luftfuktighet</div>
              <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '2.2rem', fontWeight: 700, color: '#FFFFFF', marginTop: '4px' }}>{weatherData.humidity}%</div>
            </div>
            <div>
              <div style={{ fontFamily: "'Inter', sans-serif", fontSize: '0.95rem', color: 'var(--theme-accent, #FFD700)', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Nedbør</div>
              <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '2.2rem', fontWeight: 700, color: '#FFFFFF', marginTop: '4px' }}>{weatherData.precipitation} mm</div>
            </div>
            <div>
              <div style={{ fontFamily: "'Inter', sans-serif", fontSize: '0.95rem', color: 'var(--theme-accent, #FFD700)', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Skydekke</div>
              <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '2.2rem', fontWeight: 700, color: '#FFFFFF', marginTop: '4px' }}>{weatherData.cloud_cover}%</div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div
          className={weatherLeaving ? 'weather-footer-exit' : 'weather-footer-enter'}
          style={{
            padding: '12px 28px', borderTop: '3px solid var(--theme-panel-border, rgba(255,215,0,0.5))',
            background: 'linear-gradient(135deg, var(--theme-header-gradient, rgba(30,58,95,0.9)) 0%, transparent 100%)',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between'
          }}
        >
          <div style={{ fontFamily: "'Inter', sans-serif", fontSize: '1rem', color: 'var(--theme-accent, #FFD700)', fontWeight: 600 }}>
            OPEN-METEO.COM
          </div>
          <div style={{ fontFamily: "'Inter', sans-serif", fontSize: '1rem', color: 'rgba(255,255,255,0.4)' }}>
            SØRLANDETS TRAVPARK
          </div>
        </div>
      </div>
    </div>
  );
}
